var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.885,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7f7f7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon2",
    transform: "translate(-990 -280)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4839",
    "data-name": "\\uC0AC\\uAC01\\uD615 4839",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(990 280)",
    fill: "#eaf0f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(1002.001 269.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33577",
    "data-name": "\\uD328\\uC2A4 33577",
    d: "M25.989,79.987,23.8,62.926a1.535,1.535,0,0,0-1.52-1.514H1.52A1.536,1.536,0,0,0,0,62.96V81.946A1.536,1.536,0,0,0,1.52,83.5h15.2a5.691,5.691,0,0,0,3.057-.854l1.744-1.053h2.952a1.588,1.588,0,0,0,1.187-.546,1.34,1.34,0,0,0,.328-1.054Z",
    transform: "translate(-0.001 -35.84)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33578",
    "data-name": "\\uD328\\uC2A4 33578",
    d: "M428.284,107.8,426.1,90.678c0,.011,0,.022,0,.034v17.072a.417.417,0,0,1-.2.357l-2.081,1.261h2.952a1.586,1.586,0,0,0,1.187-.548,1.347,1.347,0,0,0,.328-1.058Z",
    transform: "translate(-402.296 -63.619)",
    fill: "#ced4df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33579",
    "data-name": "\\uD328\\uC2A4 33579",
    d: "M316.079,396.63l3.825-2.269a.406.406,0,0,0,.2-.349l-3.875-1.39a.406.406,0,0,0-.355.068.434.434,0,0,0-.161.324c-.3,4.315-2.4,4.455-3.559,4.455h.869A5.77,5.77,0,0,0,316.079,396.63Z",
    transform: "translate(-296.302 -349.813)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33580",
    "data-name": "\\uD328\\uC2A4 33580",
    d: "M22.281,61.412H1.519A1.521,1.521,0,0,0,0,62.931v2.82H23.8v-2.82a1.521,1.521,0,0,0-1.52-1.519Z",
    transform: "translate(0 -35.84)",
    fill: "#f15d5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33581",
    "data-name": "\\uD328\\uC2A4 33581",
    d: "M0,135.481H23.8v.578H0Z",
    transform: "translate(0 -106.048)",
    fill: "#e55a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33582",
    "data-name": "\\uD328\\uC2A4 33582",
    d: "M364.285,27.159a.6.6,0,0,1-.446-.146v-2.4a.753.753,0,0,1,.892,0v.959h.813V24.6c0-.53-.553-.945-1.258-.945s-1.258.415-1.258.945v2.427c0,.53.553.945,1.258.945a.406.406,0,0,0,0-.812Z",
    transform: "translate(-344.593)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33583",
    "data-name": "\\uD328\\uC2A4 33583",
    d: "M261.984,27.159a.6.6,0,0,1-.446-.146v-2.4a.753.753,0,0,1,.892,0v.959h.813V24.6c0-.53-.553-.945-1.258-.945s-1.258.415-1.258.945v2.427c0,.53.553.945,1.258.945a.406.406,0,1,0,0-.812Z",
    transform: "translate(-247.487)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33584",
    "data-name": "\\uD328\\uC2A4 33584",
    d: "M159.683,27.159a.6.6,0,0,1-.446-.146v-2.4a.753.753,0,0,1,.892,0v.958h.813V24.6c0-.53-.553-.945-1.258-.945s-1.258.415-1.258.945v2.427c0,.53.553.945,1.258.945a.406.406,0,1,0,0-.812Z",
    transform: "translate(-150.381 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33585",
    "data-name": "\\uD328\\uC2A4 33585",
    d: "M57.383,27.159a.6.6,0,0,1-.446-.146v-2.4a.753.753,0,0,1,.892,0v.958h.812V24.6c0-.53-.553-.945-1.258-.945s-1.258.415-1.258.945v2.427c0,.53.553.945,1.258.945a.406.406,0,1,0,0-.812Z",
    transform: "translate(-53.276 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56272",
    "data-name": "\\uADF8\\uB8F9 56272",
    transform: "translate(3.369 26.791)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33586",
    "data-name": "\\uD328\\uC2A4 33586",
    d: "M374,85.409a.77.77,0,0,0-.446.142v.079a.6.6,0,0,0,.446.146.406.406,0,1,1,0,.812,1.566,1.566,0,0,1-.739-.175.774.774,0,1,0,.739-1Z",
    transform: "translate(-357.673 -85.409)",
    fill: "#e55a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33587",
    "data-name": "\\uD328\\uC2A4 33587",
    d: "M271.7,85.409a.77.77,0,0,0-.446.142v.079a.6.6,0,0,0,.446.146.406.406,0,1,1,0,.812,1.566,1.566,0,0,1-.739-.175.774.774,0,1,0,.739-1Z",
    transform: "translate(-260.567 -85.409)",
    fill: "#e55a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33588",
    "data-name": "\\uD328\\uC2A4 33588",
    d: "M169.394,85.409a.77.77,0,0,0-.446.142v.079a.6.6,0,0,0,.446.146.406.406,0,1,1,0,.813,1.566,1.566,0,0,1-.739-.175.774.774,0,1,0,.739-1Z",
    transform: "translate(-163.461 -85.409)",
    fill: "#e55a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33589",
    "data-name": "\\uD328\\uC2A4 33589",
    d: "M67.094,85.409a.77.77,0,0,0-.446.142v.079a.6.6,0,0,0,.446.146.406.406,0,1,1,0,.812,1.566,1.566,0,0,1-.739-.175.774.774,0,1,0,.739-1Z",
    transform: "translate(-66.355 -85.409)",
    fill: "#e55a5a"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon2);
export default __webpack_public_path__ + "static/media/sec1Icon2.cc3a28872d8fa753b12e83a5bc0a3bff.svg";
export { ForwardRef as ReactComponent };